
export const Multipleprogress = [
  { class1: "primary", class2: 'secondary', class3: 'success', now1: 5, now2: 10, now3: 15, size: "xs",margin:"mb-3" },
  { class1: "warning", class2: 'info', class3: 'danger', now1: 10, now2: 15, now3: 20, size: "sm",margin:"mb-3"  },
  { class1: "info", class2: 'success', class3: 'primary', now1: 15, now2: 20, now3: 25, size: "",margin:"mb-3"  },
  { class1: "purple", class2: 'teal', class3: 'orange', now1: 20, now2: 25, now3: 30, size: "lg",margin:"mb-3"  },
  { class1: "success", class2: 'danger', class3: 'warning', now1: 25, now2: 30, now3: 35, size: "xl",margin:""  },

];

export const CustomProgress2data = [
  { class: 'primary', now: 50, class1: '', class2: '',margin:"mb-4" },
  { class: 'secondary', now: 60, class1: '', class2: 'secondary',margin:"mb-4" },
  { class: 'success', now: 70, class1: '', class2: 'success',margin:"mb-4" },
  { class: 'info', now: 80, class1: 'info', class2: 'info',margin:"mb-4" },
  { class: 'warning', now: 90, class1: 'warning', class2: 'warning',margin:"" },
];

export const CustomProgress4data = [
  { class: 'primary-gradient', class1: 'primary', now: 10, text: '10%' },
  { class: 'secondary-gradient', class1: 'secondary', now: 20, text: '20%' },
  { class: 'success-gradient', class1: 'success', now: 40, text: '40%' },
  { class: 'info-gradient', class1: 'info', now: 60, text: '60%' },
  { class: 'warning-gradient', class1: 'warning', now: 80, text: '80%' },
  { class: 'danger-gradient', class1: 'danger', now: 90, text: '90%' },
];

